// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { AccordionHeader } = require('commonsComponents/accordionHeader');

// @ Constants
const { okInsuranceConstants: { insuranceRequestHome } } = require('ok-insurance');
// @ constants
const { INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION, MORTGAGE_BONUSES } = require('constants/flagBasedFeatures');

// @ components
const MortgageBuildInsuranceRelatedPanelOption = require('./mortgageRequestInsurancesPanelOption');
const DisclaimerMessageInsurancesRelated = require('./disclaimerMessageInsurancesRelated');

// @ actions
const mortgageRequestInsurancesRelatedActions = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');
const { okInsuranceActions: { insuranceRequestRelatedState } } = require('ok-insurance');
const mortgageRequestInsurancesActions = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');
const mortgageRequestActions = require('actions/mortgageRequest/mortgageRequestPreApproval');

// @utilities
const { checkIfBudgetIsConfirmed } = require('utilities/mortgageHelper');

class MortgageRequestManagerPanelInsurancesRelated extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        };

        this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
        this.getInsuranceState = this.getInsuranceState.bind(this);
    }

    componentDidMount() {
        const {
            currentCaseId,
            getInsuranceRNCState,
            getInsuranceStatus,
            hasInsurance,
            insuranceRelatedRNCState,
            getCatalogInformation,
            insuranceRelatedState,
            isClientWithoutAccounts,
        } = this.props;

        getCatalogInformation();
        const insuranceState = isClientWithoutAccounts ? insuranceRelatedRNCState : insuranceRelatedState;
        if (isClientWithoutAccounts && !hasInsurance && insuranceState.get('data')) {
            getInsuranceRNCState(false, currentCaseId);
        }

        const insuranceStateData = insuranceState.get('data');

        if (!!insuranceStateData) {
            const insuranceId = insuranceStateData.get('id');
            getInsuranceStatus(insuranceId);
        }
    }

    buildStatusStep(classNameValue) {
        const { mortgageInsuranceState } = this.props;

        const mortgageInsuranceStatus = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice'])
        const activeStep = <h2 className={classNameValue}>3</h2>;
        const stepApproved = <span className="mortgage-request-manager-panel-steps__ico--step-approved"></span>;
        const elementStatus = mortgageInsuranceStatus ? stepApproved : activeStep;

        return elementStatus;
    }

    checkIfInsuranceIsRestricted() {
        const insuranceState = this.getInsuranceState();
        if (insuranceState) {
            const stateAppraisal = insuranceState.getIn(['appraisal', 'state']);
            const { WORKFLOW_STATE } = insuranceRequestHome;

            return WORKFLOW_STATE.includes(stateAppraisal);
        }

        return false;
    }

    isPostAppraisal() {
        const insuranceState = this.getInsuranceState();
        return insuranceState.getIn(['appraisal', 'afterAppraisal']);
    }

    postalCodeHasDiscrepancy() {
        const {
            flagBasedFeatures,
            hasInsurance
        } = this.props;
        const insuranceState = this.getInsuranceState();
        const preAppraisalNotificationFlag = flagBasedFeatures.get(INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION);
        const appraisalPostalCode = insuranceState.getIn(['appraisal', 'property', 'postalCode']);
        const currentPostalCode = insuranceState.getIn(['data', 'home', 'postalCode']);
        return preAppraisalNotificationFlag && hasInsurance && !this.isPostAppraisal() && appraisalPostalCode && currentPostalCode && (appraisalPostalCode !== currentPostalCode);
    }

    buildNotificationIcon() {
        const { hasInsurance, mortgageInsuranceState } = this.props;
        const insuranceState = this.getInsuranceState();
        const relatedState = insuranceState.get('data');
        const simulationExists = relatedState !== null;
        const budgetConfirmed = checkIfBudgetIsConfirmed(relatedState);
        const showNotificationIcon = this.isPostAppraisal() && simulationExists && !budgetConfirmed && !this.checkIfInsuranceIsRestricted();
        const AppraisalWithoutPrevSimulation = !relatedState && this.isPostAppraisal() && hasInsurance;
        const isPriceClosed = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);

        if (!this.checkIfShowSpecialAppliesMessage() && (this.postalCodeHasDiscrepancy() || showNotificationIcon || AppraisalWithoutPrevSimulation) && !isPriceClosed) {
            return <span className="mortgage-request-manager-panel-steps__notification-icon">1</span>;
        }
    }

    checkIfShowSpecialAppliesMessage() {
        const {
            insuranceRelatedState,
            insuranceRelatedRNCState,
            mortgageInsuranceState,
            isClientWithoutAccounts,
            hasInsurance
        } = this.props;
        const insuranceState = isClientWithoutAccounts ? insuranceRelatedRNCState : insuranceRelatedState;
        const insuranceStateData = insuranceState.get('data');
        const isClosedPrice = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);
        const isLimitsFlagEnabled = insuranceStateData && insuranceStateData.get('ccLimitsFlag');
        return !__CONTACT_CENTER__ && hasInsurance && isLimitsFlagEnabled && !isClosedPrice;
    }

    buildMortgagePanelOption(insuranceStateData, mortgageHasInsuranceRelated, isInsuranceRestricted, disclaimerMessage, isBonusAvaiable) {
        const {
            flagBasedFeatures,
            mortgageInsuranceState,
            mortgageInsurancesCancel,
            mortgageInsurancesLink,
            accountHolder,
            immMortgageRequest,
            isFetching,
            history,
        } = this.props;
        const subTypeDocument = immMortgageRequest.get('subTypeDocumentID');

        return (
            <MortgageBuildInsuranceRelatedPanelOption
                flagBasedFeatures={flagBasedFeatures}
                isBonusAvaiable={isBonusAvaiable}
                isFetching={isFetching}
                accountHolder={accountHolder}
                subTypeDocument={subTypeDocument}
                hasInsurance={mortgageHasInsuranceRelated}
                disclaimerMessage={disclaimerMessage}
                insuranceStateData={insuranceStateData}
                mortgageInsuranceState={mortgageInsuranceState}
                mortgageInsurancesCancel={mortgageInsurancesCancel}
                showSpecialAppliesMessage={this.checkIfShowSpecialAppliesMessage()}
                mortgageInsurancesLink={(includesHomeInsurance, redirectToPanel = true) => mortgageInsurancesLink(includesHomeInsurance, redirectToPanel, history)}
                isInsuranceRestricted={isInsuranceRestricted}
            />
        );
    }

    buildPanelOptionDescription(hasInsurance, insuranceData, isBonusAvaiable) {
        const { mortgageInsuranceState } = this.props;
        const isPriceClosed = mortgageInsuranceState.getIn(['insurancesRelatedStatusData', 'closedPrice']);
        const bonusKey = 'mortgageRequestPanel-mortgageRequestPanel_insuranceRelatedBonusContractedSuccess';

        let insuranceDescriptionMessage = null;

        if (isPriceClosed) {
            insuranceDescriptionMessage = 'mortgageRequestPanel-insuranceRelatedContractedSuccess';
        } else if (hasInsurance) {
            insuranceDescriptionMessage = 'mortgageRequestPanel-insurancesRelatedDescription';
        } else if (!hasInsurance || insuranceData === null) {
            insuranceDescriptionMessage = 'mortgageRequestPanel-notInsurancesRelatedDescription';
        }

        return !this.checkIfShowSpecialAppliesMessage() && <FormattedText value={isBonusAvaiable ? bonusKey : insuranceDescriptionMessage} />;
    }

    handleOnClickAccordion() {
        const { isExpanded } = this.state;
        const accordionState = isExpanded ? false : true;

        this.setState({ isExpanded: accordionState });
    }

    getInsuranceState() {
        const {
            insuranceRelatedRNCState,
            insuranceRelatedState,
            isClientWithoutAccounts,
        } = this.props;
        return isClientWithoutAccounts ? insuranceRelatedRNCState : insuranceRelatedState;
    }

    render() {
        const {
            hasInsurance,
            mortgageInsuranceState,
            accountHolder,
            flagBasedFeatures,
            isFetching
        } = this.props;
        const { isExpanded } = this.state;


        const isBonusAvaiable = flagBasedFeatures.get(MORTGAGE_BONUSES);
        const bonusKey = 'mortgageRequestPanel-mortgageRequestPanel_insurancesBonusRelatedTitle';
        const accordionTitleKey = isBonusAvaiable ? bonusKey : 'mortgageRequestPanel-insurancesRelatedTitle';

        const disclaimerMessage = (
            <DisclaimerMessageInsurancesRelated
                isFetching={isFetching}
                hasInsurance={hasInsurance}
                isBonusAvaiable={isBonusAvaiable}
                accountHolder={accountHolder}
                mortgageInsuranceState={mortgageInsuranceState}
                insuranceIsRestricted={this.checkIfInsuranceIsRestricted()}
                showSpecialAppliesMessage={this.checkIfShowSpecialAppliesMessage()}
                insuranceState={this.getInsuranceState()}
                isPostAppraisal={this.isPostAppraisal()}
                postalCodeHasDiscrepancy={this.postalCodeHasDiscrepancy()}
            />
        )

        const insuranceState = this.getInsuranceState();
        const insuranceStateData = insuranceState.get('data');
        const isInsuranceRestricted = this.checkIfInsuranceIsRestricted();
        const itemActive = classnames('step-item-num', {
            'step-item-num--active': hasInsurance && !insuranceStateData && isExpanded && !isInsuranceRestricted && !this.checkIfShowSpecialAppliesMessage()
        });

        const getStatusStep = this.buildStatusStep(itemActive);
        const disclaimerMessageInsurancesRelatedNotificationIcon = this.buildNotificationIcon();
        const panelOptionDescription = this.buildPanelOptionDescription(hasInsurance, insuranceStateData, isBonusAvaiable);
        const mortgageBuildInsuranceRelatedPanelOption = (isInsuranceRestricted && hasInsurance) || !isInsuranceRestricted || isBonusAvaiable
            ? this.buildMortgagePanelOption(insuranceStateData, hasInsurance, isInsuranceRestricted, disclaimerMessage, isBonusAvaiable)
            : null;
        if (
            !insuranceState.get('hasFetched') &&
            insuranceState.get('isFetching') ||
            mortgageInsuranceState.get('isFetchingInsuranceLink') ||
            mortgageInsuranceState.get('isFetching') ||
            insuranceState.get('cancelIsFetching') ||
            mortgageInsuranceState.get('isFetchingInsurancesStatus')
        ) {
            return <LoadingSection />;
        }

        return (
            <div className="row step-item">
                <div className="col-xs-1">{getStatusStep}</div>
                <div className="col-xs-11">
                    <Accordion
                        id="stepInsurancesRelated"
                        isExpanded={isExpanded}
                        customClassName="mortgage-request-manager-panel-steps__collapsable"
                        onClick={this.handleOnClickAccordion}
                    >
                        <AccordionHeader name="AccordionHeader" isRightArrowPosition={true}>
                            {disclaimerMessageInsurancesRelatedNotificationIcon}
                            <h3>
                                <FormattedText value={accordionTitleKey} />
                            </h3>
                            <p>{panelOptionDescription}</p>
                        </AccordionHeader>

                        <AccordionBody name="AccordionBody">
                            {!isBonusAvaiable ?
                                <div className="mortgage-request-manager-panel-steps__disclaimers">
                                    {disclaimerMessage}
                                </div> : null
                            }
                            {mortgageBuildInsuranceRelatedPanelOption}
                        </AccordionBody>
                    </Accordion>
                </div>
            </div>
        )
    }
}

MortgageRequestManagerPanelInsurancesRelated.propTypes = {
    currentCaseId: PropTypes.string,
    flagBasedFeatures: PropTypes.object,
    getInsuranceRNCState: PropTypes.func,
    getCatalogInformation: PropTypes.func.isRequired,
    getInsuranceStatus: PropTypes.func.isRequired,
    immMortgageRequest: PropTypes.object.isRequired,
    hasInsurance: PropTypes.bool,
    accountHolder: PropTypes.string,
    insuranceRelatedRNCState: PropTypes.object.isRequired,
    insuranceRelatedState: PropTypes.object.isRequired,
    isClientWithoutAccounts: PropTypes.bool,
    mortgageInsuranceState: PropTypes.object.isRequired,
    mortgageInsurancesCancel: PropTypes.func.isRequired,
    mortgageInsurancesLink: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    history: PropTypes.object.isRequired,
};

module.exports.MortgageRequestManagerPanelInsurancesRelated = withRouter(connect(
    state => ({
        insuranceRelatedRNCState: state.insuranceRequestRelatedRNCState,
        mortgageInsuranceState: state.mortgageRequestManagerInsuranceRelated,
        immMortgageRequest: state.mortgageRequestPreApproval,
    }), {
    getCatalogInformation: mortgageRequestActions.getCatalogInformation,
    getInsuranceStatus: mortgageRequestInsurancesRelatedActions.mortgageRequestInsurancesRelatedStatusData,
    mortgageInsurancesCancel: insuranceRequestRelatedState.mortgageRequestInsuranceCancel,
    mortgageInsurancesLink: mortgageRequestInsurancesActions.mortgageRequestInsurancesLink,
}
)(MortgageRequestManagerPanelInsurancesRelated));
